import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseDto } from '../../../shared/modules/base/dtos/base.dto';
import { PolicyStatusEnum } from '../enums/policy-status.enum';
import { PolicyTypeEnum } from '../enums/policy-type.enum';
import { PolicyConfig } from '../types/policy-config.types';

/**
 * Policy DTO for records
 */
@CaslSubject(AppSubjectEnum.POLICY)
export class PolicyRecordDto extends BaseDto {
	type!: PolicyTypeEnum;
	name?: string | null;
	config!: PolicyConfig;
	notes?: string | null;
	status!: PolicyStatusEnum;
}
